export const site = {
  name: 'George Kalokyris',
  brand: 'GKhub',
  domain: 'kalokyris.com', // shown as the watermark on gallery photos
  footerNote: 'Built with React and Bootstrap.',
  role: 'Full-stack developer, currently at ESPC building Spark',
  cta: 'Get in touch',
  // Rotating hero strings. Shown as one static list when the visitor prefers reduced motion.
  typed: ['.NET Core', 'Angular', 'Microservices', 'RabbitMQ', 'PostgreSQL'],
  // Key/value rows in the hero panel (the stack row is added from `typed`).
  specs: [
    { key: 'location', value: 'Edinburgh, UK' },
    { key: 'employer', value: 'ESPC (UK)' },
    { key: 'project', value: 'Spark' },
  ],
  contactIntro: 'Questions, projects or just a hello. Send a message and I will reply by email.',
  contactMessages: {
    success: 'Thanks, your message was sent. A confirmation is on its way to your inbox.',
    sent: 'Form submission was successful!',
    failed: 'Uh oh. Something went wrong.',
    rateLimited:
      'You have sent several messages recently. Please try again in a while, or email me directly.',
    unavailable: 'Your message did not go through. Please email me directly at',
    messageTooShort: 'Please write at least 10 characters',
    messageTooLong: 'Please use 5000 characters or less',
  },
};
